/* eslint-disable indent */
const $ = require('jquery');

import 'slick-carousel';

export default {
    element: document.querySelector('.js-slider'),
    init() {
      if (this.element) {
        this.render();
      }
    },
    getHeight() {
      const details = document.querySelectorAll('.js-carousel-item-details');
      const arr = [];
      [ ...details ].forEach((item) => {
        const offsetTop = parseInt($(item).offset().top);
        if (typeof(arr[offsetTop]) == "undefined") {
          arr[offsetTop] = {items: [], heights: []};
        }
        arr[offsetTop]["items"].push(item);
        arr[offsetTop]["heights"].push(item.clientHeight);
      });
  
      arr.forEach(row => {
        const max = Math.max(...row.heights);
        row.items.forEach(item => {
          item.style.height = `${ max }px`;
        });
      });
    },
    render() {
        $('.js-slider').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          mobileFirst: true,
          variableWidth: true,
          breakpoint: this.getHeight(),
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ],
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
